export const TOURNAMENT_STORAGE_KEY_PREFIX = 'tournament_'

export interface PasswordVerificationStore {
  password: string
}

const parseLocalStorageItem = (key: string) => {
  const item = localStorage.getItem(key)
  return item ? JSON.parse(item) : null
}

export const getLocalStorageItem = (key: string) => {
  try {
    return parseLocalStorageItem(key)
  } catch (error) {
    console.error(`Error parsing localStorage item with key "${key}":`, error)
    return null
  }
}

export const setLocalStorageItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Error setting localStorage item with key "${key}":`, error)
  }
}

export const encodeString = (value: string): string => {
  try {
    const textEncoder = new TextEncoder()
    const bytes = textEncoder.encode(value)
    const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('')
    return btoa(binary)
  } catch (error) {
    return ''
  }
}

export const decodeString = (value: string): string => {
  try {
    const textDecoder = new TextDecoder()
    const binary = atob(value)
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
    return textDecoder.decode(bytes)
  } catch {
    return ''
  }
}

export const removeLocalStorageItem = (key: string): void => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error(`Error removing localStorage item with key "${key}":`, error)
  }
}
